(function() {
    'use strict';
    angular.module('wbDashboard').factory('PlanService', ['$uibModal', '$q', '$filter', 'Request', 'Track', function ($uibModal, $q, $filter, Request, Track) {
        var plan = {
                user: {}
            },

            planData = {
                "plans": null,
                "discountRate": null
            },
            userData = {
                "autos": null,
                "rollovers": null,
            },
            portfolioData = {
                "portfolios": null,
                "portfolioDetail": null,
                "userPortfolios": null,
                "portfolioPositions": null,
                "portfolioMetrics": null,
            },
            promises = {
            };

        /**
         * Returns entire planData object
         */
        plan.getPlanData = function() {
            return plan.get();
        };

        /**
         * Get specific planData key
         * @param type
         * @returns {*}
         */
        plan.get = function (type) {
            if (!type) {
                return planData;
            } else {
                return planData[type];
            }
        };
        /**
         * Clear any planData key or entire object
         * @param type
         * @returns {boolean}
         */
        plan.clear = function (type) {
            if (type) {
                if (!(type in planData)) {
                    throw new Error("PlanService: Invalid type in planData");
                }
                planData[type] = null;
            } else {
                Object.keys(planData).forEach(function(key) {
                    planData[key] = null;
                });
            }
            return true;
        };
        /**
         * Manually update any particular data in any planData key
         * @param type
         * @param data
         */
        plan.manualSet = function(type, data) {
            if (!(type in planData)) {
                throw new Error("PlanService: Invalid type in planData");
            }
            planData[type] = planData[type] || {};
            planData[type] = angular.extend(planData[type], data);
        };


        /**
         * Get all plan data that's already been retrieved
         * @returns {*}
         */
        plan.getPlans = function () {
            return plan.get('plans');
        };
        plan.getPlan = function (slug) {
            var plans = plan.get('plans');
            var returnPlan = null;

            angular.forEach(plans, function (p) {
                if (p.slug === slug) {
                    returnPlan = p;
                }
            });

            return returnPlan;
        };

        /**
         * Request all plans data from server
         * @param refresh
         * @returns {Promise|Promise<any>}
         */
        plan.retrievePlans = function(refresh) {

            if (plan.get('plans') && !refresh) {
                return $q.when(plan.get('plans'));
            } else {
                return Request.make('plans').then(function (response) {
                    planData.plans = response.data.subscriptions;
                    planData.discountRate = response.data.discount_rate;

                    angular.forEach(planData.plans, function(p) {

                        p.billing.discount = p.billing.discount_rate * 100;

                        if (p.offer) {
                            p.offer.est_end_date = moment().add(p.offer.offer_length, "days").format('YYYY-MM-DD');
                            p.billing.discount = 100;
                        }

                    });

                    return planData.plans;
                });
            }
        };
        plan.getPlanFeature = function (planSlug, featureSlug) {
            var returnFeature = false;
            var p = plan.getPlan(planSlug);
            if (p) {
                angular.forEach(p.features, function(feature) {
                    if (feature.slug === featureSlug) {
                        returnFeature = feature;
                    }
                });
            }
            return returnFeature;
        };

        /**
         * Adds a plan to a user
         * @param {Object} data
         * @param {String} data.slug
         * @param {String} data.estimated_cost
         * @param {String} data.plan_name
         * @returns {*}
         */
        plan.user.addPlan = function (data = {}) {
            return Request.make('plans_add', data).then(function (response) {
                return response.data.response;
            });
        };

        /**
         * Enables plans from anywhere in site outside of plan pages
         * @param planChoice
         * @param $scope
         * @returns {*}
         */
        plan.user.enableConfirmPlanModal = function(planChoice, $scope) {

            var $modalScope = $scope.$new();
            $modalScope.section = 'info-enable-modal-content';
            $modalScope.PS =  plan;
            $modalScope.plan = planChoice;
            $modalScope.eligibility = {
                taxableAccount: true
            };

            var templateUrl = "";
            switch (planChoice.slug) {
                case 'taxplan':
                    templateUrl = "app/themes/aurea/segments/plans/plans/taxplan/plans.info.plan.taxplan.tpl.html";
                    break;
                case 'portfolioplus':
                    templateUrl = "app/themes/aurea/segments/plans/plans/portfolioplus/plans.info.plan.portfolioplus.tpl.html";
                    $modalScope.section = 'info-enable-modal-content-plus';
                    break;
            }

            var modalInstance = $uibModal.open({
                templateUrl: templateUrl,
                size: 'md',
                scope: $modalScope,
                windowClass: 'plan-info-confirm-modal'
            });

            return modalInstance.result.catch(function () {
                //dismissed/cancelled
                throw false;
            }).then(function () {
                return plan.user.addPlan(planChoice.slug);
            }).then(function() {
                if (planChoice.slug === 'portfolioplus') {
                    return plan.user.toggleFeature('customportfolio', true);
                }
            });

        };

        /**
         * Removes a plan from a user
         * @returns {*}
         */
        plan.user.removePlan = function (slug) {
            return Request.make('plans_remove', {slug: slug}).then(function (response) {
                return response.data.response;
            });
        };

        // /**
        //  * Get users feature from a plan
        //  * @returns {*}
        //  */
        // plan.user.getPlanFeature = function (planSlug, featureSlug) {
        //     return plan.getPlanFeature(planSlug, featureSlug)
        // };
        /**
         * Removes a plan from a user
         * @returns {*}
         */
        plan.user.toggleFeature = function (slug, enabled) {
            let action = enabled ? "enable" : "disable";
            return Request.make('plans_feature_toggle', {slug: slug, action: action}).then(function (response) {
                return response.data.response;
            });
        };


        //***************************************
        //**** METHODS FOR CUSTOM FEATURES ******
        //***************************************

        //*************************************
        //**** METHODS FOR ROLLOVERS **********
        //*************************************

        plan.user.retrieveRollovers = function(refresh) {
            if (plan.user.getRollovers() && !refresh) {
                return $q.when(plan.user.getRollovers());
            } else {
                return Request.make('user_rollovers').then(function (response) {
                    var test = false;

                    if (!test) {
                        userData.rollovers = response.data.response.rollovers;
                        angular.forEach(userData.rollovers, function(r) {
                            var bankImageName = null;
                            var firmName = r.source_broker_name.toLowerCase();

                            if(firmName.includes("axos")) {
                                bankImageName = "axos-bank";

                            } else if(firmName.includes("american funds") || firmName.includes("american fund")) {
                                bankImageName = "american-funds";

                            } else if(firmName.includes("boa") || firmName.includes("bank of america") || firmName.includes("b of a")) {
                                bankImageName = "bank-of-america";

                            } else if(firmName.includes("betterment")) {
                                bankImageName = "betterment";

                            } else if(firmName.includes("capital one") || firmName.includes("cap one")) {
                                bankImageName = "capital-one";

                            } else if(firmName.includes("charles schwab") || firmName.includes("schwab")) {
                                bankImageName = "charles-schwab";

                            } else if(firmName.includes("e trade") || firmName.includes("etrade")) {
                                bankImageName = "e-trade";

                            } else if(firmName.includes("edward jones")) {
                                bankImageName = "edward-jones";

                            } else if(firmName.includes("fidelity")) {
                                bankImageName = "fidelity";

                            } else if(firmName.includes("jp morgan") || firmName.includes("chase")) {
                                bankImageName = "jp-morgan-chase";

                            } else if(firmName.includes("lpl")) {
                                bankImageName = "lpl";

                            } else if(firmName.includes("morgan stanley")) {
                                bankImageName = "morgan-stanley";

                            } else if(firmName.includes("pershing")) {
                                bankImageName = "pershing";

                            } else if(firmName.includes("raymond james")) {
                                bankImageName = "raymond-james";

                            } else if(firmName.includes("td") || firmName.includes("td ameritrade")) {
                                bankImageName = "td-ameritrade";

                            } else if(firmName.includes("tiaa") || firmName.includes("tiaa cref")) {
                                bankImageName = "tiaa-cref";

                            } else if(firmName.includes("t rowe")) {
                                bankImageName = "trowe-price";

                            } else if(firmName.includes("usaa")) {
                                bankImageName = "usaa";

                            } else if(firmName.includes("vanguard")) {
                                bankImageName = "vanguard";

                            } else if(firmName.includes("wealthfront")) {
                                bankImageName = "wealthfront";

                            } else if(firmName.includes("wells") || firmName.includes("wells fargo")) {
                                bankImageName = "wells-fargo";
                            }

                            r.bankImageName = bankImageName;

                        });
                    } else if (test) {
                        var status = [
                            'upload-statement', 'pending-statement-approval', 'liquidate', 'add-retirement', 'add-ira',
                            'ira-pending', 'ira-pending-verification', 'needs-transfer-form', 'fill-out-form', 'pending-form-approval',
                            'contact-firm',
                            'waiting-on-funds', 'investing-funds', 'complete', 'canceled'
                        ];
                        var r = [];
                        status.forEach(function (value, key) {
                            r.push({
                                "uuid": "89bfa14a-52d5-4e63-9422-43cad62e4634-" + key,
                                "status": value,
                                "target_account_type": "traditional-ira",
                                "source_account_type": "roth-ira",
                                "source_broker_name": "Bankie Bank",
                                "amount": 20,
                                "fee": 1,
                                "account_number": 12345,
                                "milestone_id": null,
                                "documents": []
                            });
                        });
                        userData.rollovers = r;
                    }
                    return userData.rollovers;

                }).catch(function (response) {
                    throw response;
                });
            }
        };
        plan.user.getRollovers = function(uuid) {
            var rollover;

            if (uuid) {
                rollover = null;
                angular.forEach(userData.rollovers, function(r) {
                    if (r.uuid === uuid) {
                        rollover = r;
                    }
                });
            } else {
                rollover = userData.rollovers;
            }
            return rollover;
        };
        plan.user.clearRollovers = function() {
            userData.rollovers = null;
        };

        /**
         * @param {Object} data
         * @param {string} [data.id]
         * @param {string} [data.source_account_type]
         * @param {string} [data.target_account_type]
         * @param {string} [data.source_broker_name]
         * @param {number} [data.amount]
         * @param {number} [data.fee]
         */
        plan.user.saveRollover = function(data) {
            return $q.when(1).then(function() {
                if (data.rollover_id) {
                    return Request.make('user_rollover_update', data);
                } else {
                    return Request.make('user_rollover_new', data);
                }
            }).then(function(response) {
                return response.data.response;
            });
        };
        plan.user.nextRolloverStep = function(rollover_id) {
            return Request.make('user_rollover_next', {
                rollover_id: rollover_id
            });
        };
        plan.user.deleteRollover = function(rollover_id) {
            return Request.make('user_rollover_delete', {
                rollover_id: rollover_id
            });
        };
        plan.user.addRolloverIRAtoMilestone = function(type) {
            return Request.make('milestone_create', {
                one_time_deposit: 0,
                account_type: type,
                auto_deposit: 0,
                annual_deposit_limit: null
            });
        };
        plan.user.getRolloverForecast = function(data) {
            if (data.fee) {
                data.fee /= 100;
            }
            return Request.make('user_rollover_forecast', {
                rollover_id: data.rollover_id,
                rollover_value: data.rollover_value,
                source_management_fee: data.fee
            }).then(function(response) {
                return response.data.response;
            });
        };

        //*************************************
        //**** METHODS FOR TAX PLAN ***********
        //*************************************

        plan.user.saveSelectiveAssets = function(data) {
            return Request.make('user_feature_selective_assets_save', {
                asset_classes: data
            }).then(function(response) {
                var assetClasses = response.data.response.asset_classes;
                formatSecuritySelection(assetClasses);
                return assetClasses;
            }).catch(function(response) {
                throw response;
            });
        };
        plan.user.getSelectiveAssets = function() {
            return Request.make('user_feature_selective_assets').then(function(response) {
                var assetClasses = response.data.response.asset_classes;
                formatSecuritySelection(assetClasses);
                return assetClasses;
            }).catch(function(response) {
                throw response;
            });
        };
        plan.user.getSelectiveAssetsDefaults = function() {
            return Request.make('user_feature_selective_assets_default').then(function(response) {
                var assetClasses = response.data.response.asset_classes;
                formatSecuritySelection(assetClasses);
                return assetClasses;
            }).catch(function(response) {
                throw response;
            });
        };
        function formatSecuritySelection(assetClasses) {
            return assetClasses;
        }

        plan.user.getWiseHarvestingData = function() {
            return Request.make('user_metrics', {metric: 'wiseharvesting'}).then(function(response) {
                return response.data.response;
            }).catch(function(response) {
                throw response;
            });
        };

        plan.user.getIraForecast = function() {
            return Request.make('user_ira_forecast').then(function(response) {
                return response.data.forecast;
            }).catch(function(response) {
                throw response;
            });
        };

        /**
         * @param {Object} data
         * @param {Object[]} data.accounts
         * @param {string} data.accounts.account_number
         * @param {number} data.accounts.annual_deposit_limit
         */
        plan.user.updateAnnualDepositLimits = function(data) {
            return Request.make('user_annual_deposit_limits', data).then(function(response) {
                return response.data.response;
            }).catch(function(response) {
                throw response;
            });
        };


        //*************************************
        //**** METHODS FOR FAST MONEY *********
        //*************************************

        plan.user.retrieveAutos = function() {
            return Request.make('user_autos').then(function(response) {
                var autos = response.data.response;
                angular.forEach(autos.frequency_dates, function(value, key) {
                    autos.frequency_dates[key] = parseInt(value);
                });

                autos.total_available = 50000 - (autos.total_auto_deposit || 0);

                var date = moment(autos.next_auto_deposit_date, "MM-DD-YYYY");
                autos.next_auto_deposit_date = date.toDate();
                autos.frequency_start_date = date.format("MM/DD/YYYY");

                userData.autos = autos;
                return userData.autos;
            }).catch(function(response) {
                throw response;
            });
        };
        plan.user.getAutos = function() {
            if (!userData.autos) {
                //fallback just in case so inputs still work
                //must be defined external to this method or get watchers will trigger over and over again
                return plan.user.getAutos.fallback;
            }
            return userData.autos;
        };
        plan.user.getAutos.fallback = {
            total_available: 50000
        };

        /**
         * @param {Object} data
         * @param {string} data.frequency
         * @param {Array} data.frequency_dates
         * @param {string} data.frequency_weekday
         */
        plan.user.updateAutos = function(data) {
            return Request.make('user_autos_update', data).then(function(response) {
                return response.data.response;
            }).catch(function(response) {
                throw response;
            });
        };


        //*************************************
        //**** METHODS FOR PORTFOLIO PLUS *****
        //*************************************

        plan.retrievePortfolios = function(type, refresh) {
            if (plan.getPortfolios(type) && !refresh) {
                return $q.when(plan.getPortfolios(type));
            } else {
                var pType = type || null;
                return Request.make('portfolios', {type: pType}).then(function (response) {
                    /* jshint expr: true */
                    portfolioData.portfolios || (portfolioData.portfolios = {});
                    portfolioData.portfolios[type] = {
                        featured: response.data.response.featured_portfolio,
                        list: response.data.response.portfolios
                    };

                    angular.forEach(response.data.response.portfolios, function(p) {
                        setPortfolioImage(p);
                    });
                    setPortfolioImage(response.data.response.featured_portfolio);

                    function setPortfolioImage(p) {
                        var assetPercent = 0;
                        angular.forEach(p.asset_classes, function(ac) {
                            if (ac.target_allocation_rate > assetPercent) {
                                p.imageAsset = ac.code;
                                assetPercent = ac.target_allocation_rate;
                            }
                        });

                    }


                    return portfolioData.portfolios[type];
                }).catch(function (response) {
                    throw response;
                });
            }
        };
        plan.getPortfolios = function(type) {
            if (portfolioData.portfolios) {
                return portfolioData.portfolios[type];
            }
        };

        plan.retrievePortfolioDetail = function(slug, refresh) {
            if (plan.getPortfolioDetail(slug) && !refresh) {
                return $q.when(plan.getPortfolioDetail(type));
            } else {
                return Request.make('portfolio_detail', {pslug: slug}).then(function (response) {
                    /* jshint expr: true */
                    portfolioData.portfolioDetail || (portfolioData.portfolioDetail = {});
                    portfolioData.portfolioDetail[slug] = response.data.response;
                    return portfolioData.portfolioDetail[slug];
                }).catch(function (response) {
                    throw response;
                });
            }
        };
        plan.getPortfolioDetail = function(slug) {
            if (portfolioData.portfolioDetail) {
                return portfolioData.portfolioDetail[slug];
            }
        };

        plan.user.retrievePortfolios = function(slug, refresh) {
            if (plan.user.getPortfolios() && !refresh) {
                return $q.when(plan.user.getPortfolios(slug));
            } else {
                return Request.make('user_portfolios').then(function (response) {
                    var portfolios = response.data.response.portfolios;

                    /* jshint expr: true */
                    portfolioData.userPortfolios || (portfolioData.userPortfolios = {});

                    angular.copy({}, portfolioData.userPortfolios);
                    angular.forEach(portfolios, function(p) {
                        portfolioData.userPortfolios[p.slug] = p;
                        var assetPercent = 0;
                        angular.forEach(p.asset_classes, function(ac) {
                            if (ac.target_allocation_rate > assetPercent) {
                                p.imageAsset = ac.code;
                                assetPercent = ac.target_allocation_rate;
                            }
                        });
                    });

                    return plan.user.getPortfolios(slug);
                }).catch(function (response) {
                    throw response;
                });
            }
        };
        plan.user.getPortfolios = function(slug) {
            if (slug && plan.user.getPortfolios()) {
                var portfolios = plan.user.getPortfolios();
                if (slug in portfolios) {
                    return portfolios[slug];
                } else {
                    return null;
                }
            } else {
                return portfolioData.userPortfolios;
            }
        };
        plan.user.getPortfolioName = function(slug) {
            if (0 <= slug*1 && slug*1 <= 10) {
                return "Managed Portfolios Core";
            } else {
                var portfolio = plan.user.getPortfolios(slug);
                if (portfolio) {
                    return portfolio.name;
                }
            }
        };
        plan.user.getPortfolioImgAsset = function(slug) {
            if (0 <= slug*1 && slug*1 <= 10) {
                return "CORE";
            } else {
                var portfolio = plan.user.getPortfolios(slug);
                if (portfolio) {
                    return portfolio.imageAsset;
                }
            }
        };

        plan.user.retrievePortfolioPositions = function(slug, refresh) {
            if (plan.user.getPortfolioPositions(slug) && !refresh) {
                return $q.when(plan.user.getPortfolioPositions(slug));
            } else {
                return Request.make('user_portfolio_positions', {pslug: slug}).then(function (response) {
                    /* jshint expr: true */
                    portfolioData.portfolioPositions || (portfolioData.portfolioPositions = {});
                    portfolioData.portfolioPositions[slug] = response.data.response;
                    return portfolioData.portfolioPositions[slug];
                }).catch(function (response) {
                    throw response;
                });
            }
        };
        plan.user.getPortfolioPositions = function(slug) {
            if (portfolioData.portfolioPositions) {
                return portfolioData.portfolioPositions[slug];
            }
        };
        plan.user.retrievePortfolioMetrics = function(slug, refresh) {
            if (plan.user.getPortfolioMetrics(slug) && !refresh) {
                return $q.when(plan.user.getPortfolioMetrics(slug));
            } else {
                return Request.make('user_portfolio_metrics', {pslug: slug}).then(function (response) {
                    /* jshint expr: true */
                    portfolioData.portfolioMetrics || (portfolioData.portfolioMetrics = {});

                    portfolioData.portfolioMetrics[slug] = response.data.response;
                    return portfolioData.portfolioMetrics[slug];
                }).catch(function (response) {
                    throw response;
                });
            }
        };
        plan.user.getPortfolioMetrics = function(slug) {
            if (portfolioData.portfolioMetrics) {
                return portfolioData.portfolioMetrics[slug];
            }
        };

        plan.user.clearPortfolioExtra = function() {
            portfolioData.portfolioPositions = null;
            portfolioData.portfolioMetrics = null;
        };

        plan.user.formatPortfolioAllocation = function(portfolioPositions) {
            var cash = 0;
            var portfolioAllocation = {
                total_value: portfolioPositions.market_value,
                bond_percent: portfolioPositions.actual_bond_rate * 100,
                stock_percent: portfolioPositions.actual_stock_rate * 100,
                positions: []
            };

            var assetNames = {};
            angular.forEach(portfolioPositions.asset_classes, function(asset, index) {
                assetNames[asset.code] = asset.name;
            });
            angular.forEach(portfolioPositions.positions, function(position, index) {
                var newPosition = angular.copy(position);

                newPosition.code = position.asset_class;
                newPosition.percent  = position.allocation_rate * 100;
                newPosition.description  = assetNames[position.asset_class];
                if (newPosition.code === "USD") {
                    newPosition.description = "Ca$h Money";
                }

                portfolioAllocation.positions.push(newPosition);

                if (position.category === "Cash") {
                    cash = position.market_value;
                }
            });

            portfolioAllocation.cash_value = cash;

            return portfolioAllocation;
        };

        /**
         * @param {string} msId
         * @param {Object} data
         * @param {string} data.allocation_start
         * @param {string} data.allocation_end
         * @param {number} data.cash_start
         * @param {number} data.cash_end
         */
        plan.user.setMilestoneAllocation = function(msId, data) {
            data.msId = msId;
            return Request.make('user_portfolio_milestone_allocation', data).then(function (response) {
                return response.data.response;
            }).catch(function (response) {
                throw response;
            });
        };
        plan.user.savePortfolio = function(data) {
            return Request.make('user_portfolio_save', data).then(function (response) {
                return response.data.response;
            }).catch(function (response) {
                throw response;
            });
        };
        plan.user.updatePortfolio = function(slug, data) {
            data.pslug = slug;
            return Request.make('user_portfolio_update', data).then(function (response) {
                return response.data.response;
            }).catch(function (response) {
                throw response;
            });
        };
        plan.user.removePortfolio = function(slug) {
            return Request.make('user_portfolio_remove', {pslug: slug}).then(function (response) {
                return response.data.response;
            }).catch(function (response) {
                throw response;
            });
        };



        //***************************************
        //**** PLAN HARDCODED INFO **************
        //***************************************

        plan.info = {
            taxplan: {
                name: "Tax Protection",
                blurb_on: "We're making sure your returns pad your wallet (and not the tax man's).",
                blurb_off: "Hate paying taxes? Who doesn't? Use this to lower your tax bill each year.",
                features: {
                    wiseharvesting: {
                        blurb: ""
                    },
                    securityselection: {
                        blurb: ""
                    },
                    rothconversions: {
                        blurb: ""
                    },
                    taxpreferredaccount: {
                        blurb: ""
                    }
                }
            },
            fastmoney: {
                name: "Fast Money",
                blurb_on: "You've added an extra level of deposit speed and timing.",
                blurb_off: "Increase the speed and timing of your deposits.",
                features: {
                    quickdeposit: {
                        blurb: ""
                    },
                    flexibleautodeposits: {
                        blurb: ""
                    },
                },
                flexibleautodeposits: {
                    frequencies: [
                        {
                            title: 'Once A Week',
                            text: 'Weekly auto-deposits.',
                            frequency: 'Weekly',
                        },
                        {
                            title: 'Once A Month',
                            text: 'Monthly auto-deposits.',
                            frequency: 'Monthly'
                        },
                        {
                            title: 'Twice Monthly',
                            text: 'Choose two days of the month (e.g, 1st and 15th).',
                            frequency: 'Twice-Monthly'
                        },
                        {
                            title: 'Bi-Weekly',
                            text: 'Every other week. You choose when it starts.',
                            frequency: 'Bi-Weekly'
                        },
                        {
                            title: 'Once A Quarter',
                            text: 'Quarterly auto-deposits initiated on the 1st of every quarter.',
                            frequency: 'Quarterly'
                        }
                    ]
                }
            },
            portfolioplus: {
                name: "Portfolio Plus",
                blurb_on: "We're putting your investment vision to work.",
                blurb_off: "Expand your investment options to put your vision to work.",
                features: {
                    customportfolio: {
                        blurb: ""
                    }
                }
            },
        };



        return plan;
    }]);
})();
